import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Importaciones de módulos.
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

// Importaciones de componentes.
import { ActivationDialogComponent } from './activation-dialog.component';

@NgModule({
  declarations: [ActivationDialogComponent],
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  exports: [ActivationDialogComponent],
})
export class ActivationDialogModule {}
